import './Home.css'
import '../../App.css'
// import Header from '../../components/header/Header'
import Footer from '../../components/Footer/Footer'
import Menu from '../../components/menu/Menu'
import MobileMenu from '../../components/mobile_tabmennu/MobileMenu'
// import homePageImage from '../../assets/homepage4.png'
// import homeBottomShape from '../../assets/home-bottom-shape.png'
import { UseScrollToTop } from '../../components/scrollTop/ScrollTop';
import CustomSlider from '../../slider/components/custom.slider'
import images from '../../slider/data/images'
// import MapsHomeWorkOutlinedIcon from '@mui/icons-material/MapsHomeWorkOutlined';
import solutionImage from '../../assets/officepic.jpg'
// import im from '../../assets/slider-1.jpg'
// import techsofticon from '../../assets/icon-1.svg'
import homebackgroundImage from '../../assets/backgroundimage.jpg'
import { Link } from 'react-router-dom'
import HardwareDefaultimg from '../../assets/software-developmentorange.png'

import HardwareWhiteimg from '../../assets/software-developmentwhite.png'


import PrototypeDefaultimg from '../../assets/prototypeorange.png'
import Prototypewhiteimg from '../../assets/prototype.png'

import LinuxDefaultimg from '../../assets/intelligenceorange.png'
import LinuxWhiteimg from '../../assets/intelligencewhite.png'

import Qualityicon from '../../assets/quality1.png'
import Customerreviewicon from '../../assets/customer-review.png'
import EdgeIcon from '../../assets/edge-computing.png'
import EndtoEndsupport from '../../assets/customer-support.png'
import HighQuality from '../../assets/high-quality.png'
import Security from '../../assets/cyber-security.png'

const Homemine=()=> {
    return (
      <div class="wrap" style={{backgroundImage:`url(${homebackgroundImage})`}}>
            <UseScrollToTop/>

        {/* <div className="app-pc-menu top-bar">
          <Header />
        </div> */}
        <div className="app-pc-menu">
          <Menu page={'HOME'}/>
        </div>
        <div className="app-mobile-menu">
          <MobileMenu />
        </div>

        <div >
            <CustomSlider>
                {images.map((image, index) => {
                return <div key={image.key} className="slider-continar" >
                  {image.ui()}
                  </div>;
                })}
            </CustomSlider>
        </div>

       <div className='our-service-container'>
        <p className='min-header-text'>WHAT WE DO</p>
        <p className='main-header-text'>Our Services</p>
            <div className='our-service-items'>
                  <div className="consulting-card">
                  <div className="content">
                    <div className="icon">
                      <img className='defaultimg' src={HardwareDefaultimg}/>
                      <img className='whiteimg' src={HardwareWhiteimg}/>
                    </div>
                    <h3>Software Development</h3>
                    <p>
                    We are a committed group of software experts specializing in providing a diverse array of services, such as Software Solutions, IT Support, Web Development and Design. Our main aim is to utilize cutting-edge technologies
                    to promote the development and achievement of both current and future business objectives.
                    </p>
                  </div>
                </div>

                <div className="consulting-card">
            <div className="content">
              <div className="icon">
                
              <img className='defaultimg' src={PrototypeDefaultimg}/>
              <img className='whiteimg' src={Prototypewhiteimg}/>
              </div>
              <h3>Digital Infrastructure</h3>
              <p>
              Our vision is to be the digital infrastructure company that the world’s leading businesses choose to connect with. We understand the importance of connectivity and the impact it has on the overall user and customer experience.
              Without connectivity, there is no digital infrastructure
              </p>
            </div>
          </div>

          <div className="consulting-card">
            <div className="content">
              <div className="icon">
                
              <img className='defaultimg' src={LinuxDefaultimg}/>
              <img className='whiteimg' src={LinuxWhiteimg}/>
              </div>
              <h3> Innovation</h3>
              <p>
              A company dedicated to digital transformation with comprehensive responsibility for the outcomes of your digital investments, thereby enhancing your business. It provides a range of products and services aimed at effectively managing the digital thread throughout the entire life cycle of your products.
              </p>
            </div>
          </div>
            </div>   
            <div style={{magin:"0 auto", width:"100%", display:"none", justifyContent:"center", alignItems:"center", height:"5rem"}}>
            <Link to={'/contactus'} style={{textDecoration:"none", textTransform:"none"}} >
               <button  className='menu-get-it-support' style={{width:"15rem", height:"4rem", fontSize:"1.3rem"}}>Get it support</button>  
            </Link>
            </div>
       </div>


       <div className='iot-solution-container'>
          <div className='iot-solution-text'>
          <p style={{textAlign:"left"}} className='min-header-text'>Technology Solution Company</p>
          <p style={{textAlign:"left"}} className='main-header-text'>The influence of technology on societal behaviors and business strategies is undeniably increasing, along with the rising expectations of customers and employees regarding the capabilities of 
          <br/><span> technology services </span> </p>
          <p className='iot-solution-details-text'>
          We provide a comprehensive array of services to steer your organization in the right direction. As a consulting firm specializing in technology solutions
          </p>
          <div className='iot-solution-details-text-with-leftline'>
          Enterprise application support, all stages of custom application development, and advanced technologies such as Artificial intelligence, Augmented Reality, Automation and Cloud computing.
          </div>
          </div>
          <div className='iot-solution-img'>
            <img src={solutionImage} ></img>
          </div>
       </div>

              
            
                    
                   
       <div className='our-service-container'>
        {/* <p className='min-header-text'>KMPS So Different?</p> */}
        <p className='main-header-text'>Why Trust Us?</p>
        <div className='tectsoft-items'>
       
                      <div className='tectsoft-item'>
                        <div className='tectsoft-item-image'>
                          <img src={Qualityicon}/>
                        </div>
                        <div className='tectsoft-item-text-container'>
                          <p className='tectsoft-item-text-header'>Proven Expertise</p>
                          <p className='iot-solution-details-text' style={{lineHeight:"1.5rem"}}>
                          Our team has a track record of success across diverse projects, bringing years of experience and industry knowledge to every solution we develop.
                          </p>
                        </div>
                      </div>

                      <div className='tectsoft-item'>
                        <div className='tectsoft-item-image'>
                          <img src={Customerreviewicon}/>
                        </div>
                        <div className='tectsoft-item-text-container'>
                          <p className='tectsoft-item-text-header'>Customer-Centric Approach</p>
                          <p className='iot-solution-details-text' style={{lineHeight:"1.5rem"}}>
                          We put our clients at the center of everything we do, prioritizing transparent communication, personalized solutions,
                          and a commitment to exceeding expectations.
                          </p>
                        </div>
                      </div>
                      <div className='tectsoft-item'>
                        <div className='tectsoft-item-image'>
                          <img src={EdgeIcon}/>
                        </div>
                        <div className='tectsoft-item-text-container'>
                          <p className='tectsoft-item-text-header'>Cutting-Edge Solutions</p>
                          <p className='iot-solution-details-text' style={{lineHeight:"1.5rem"}}>
                          We leverage the latest technologies and best practices to ensure your solutions are future-ready, secure, and optimized for performance.
                          </p>
                        </div>
                      </div>
                      <div className='tectsoft-item'>
                        <div className='tectsoft-item-image'>
                          <img src={EndtoEndsupport}/>
                        </div>
                        <div className='tectsoft-item-text-container'>
                          <p className='tectsoft-item-text-header'>End-to-End Support</p>
                          <p className='iot-solution-details-text' style={{lineHeight:"1.5rem"}}>
                          From initial consultation to ongoing support, we’re here every step of the way, ensuring your project’s success and your satisfaction.
                          </p>
                        </div>
                      </div>
                      <div className='tectsoft-item'>
                        <div className='tectsoft-item-image'>
                          <img src={HighQuality}/>
                        </div>
                        <div className='tectsoft-item-text-container'>
                          <p className='tectsoft-item-text-header'>Quality You Can Count On</p>
                          <p className='iot-solution-details-text' style={{lineHeight:"1.5rem"}}>
                          Our commitment to quality and continuous improvement ensures we deliver solutions that are robust,
                          reliable, and built to last.
                          </p>
                        </div>
                      </div>
                      <div className='tectsoft-item'>
                        <div className='tectsoft-item-image'>
                          <img src={Security}/>
                        </div>
                        <div className='tectsoft-item-text-container'>
                          <p className='tectsoft-item-text-header'>Uncompromising Security Standards</p>
                          <p className='iot-solution-details-text' style={{lineHeight:"1.5rem"}}>
                          We prioritize the security of your data and systems, employing robust encryption, and compliance with industry standards to protect against threats.
                          Your trust and data privacy are at the heart of our solutions.
                          </p>
                        </div>
                      </div>
                  
        
        </div>
        </div>   


        <div className='let-talk-now-container'>
          <div className='let-talk-now-header'>
          We’re here to help and answer any question you might have.
          </div>
          <p className='let-talk-now-text'></p>

          <div style={{magin:"0 auto", width:"100%", display:"flex", justifyContent:"center", alignItems:"center", height:"5rem"}}>
          <Link to={'/contactus'} style={{textDecoration:"none", textTransform:"none"}} >
           <button  className='let-talk-now' style={{width:"15rem", height:"4rem", fontSize:"1.3rem"}}>Let's Talk Now</button>  
           </Link>
            </div>
        </div>  


        <Footer />
      </div>
    );
}

export default Homemine;